/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { StringProperty } from "./StringProperty";
import { NumberProperty } from "./NumberProperty";
import { BooleanProperty } from "./BooleanProperty";
import { DateProperty } from "./DateProperty";
import { EnumProperty } from "./EnumProperty";
import { ReferenceProperty } from "./ReferenceProperty";
import { ReferenceListProperty } from "./ReferenceListProperty";
import { StringListProperty } from "./StringListProperty";
import { EnumListProperty } from "./EnumListProperty";
export const Property = core.serialization
    .union("type", {
    string: StringProperty,
    number: NumberProperty,
    boolean: BooleanProperty,
    date: DateProperty,
    enum: EnumProperty,
    reference: ReferenceProperty,
    "reference-list": ReferenceListProperty,
    "string-list": StringListProperty,
    "enum-list": EnumListProperty,
})
    .transform({
    transform: (value) => value,
    untransform: (value) => value,
});
